import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminLogin } from "@/lib/api";
import { toast } from "sonner";
import { Lock, Loader2 } from "lucide-react";

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { token } = await adminLogin(password);
      localStorage.setItem("aleger_admin_token", token);
      toast.success("Willkommen");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error("Ungültiges Passwort");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0B1121] text-white flex items-center justify-center px-6 relative">
      <div className="absolute inset-0 tech-grid-bg-dark opacity-30" />
      <form
        onSubmit={onSubmit}
        data-testid="admin-login-form"
        className="relative bg-white/[0.04] border border-white/15 p-10 w-full max-w-md backdrop-blur-xl"
      >
        <div className="flex items-center justify-center h-12 w-12 bg-blue-600 mb-6">
          <Lock size={20} />
        </div>
        <h1 className="font-display font-black text-3xl">ALEGER Admin</h1>
        <p className="text-sm text-slate-400 mt-2 mb-8">Anmelden zur Verwaltung eingehender Leads.</p>

        <label className="block text-xs font-mono-tech uppercase tracking-widest text-white/60 mb-2">Passwort</label>
        <input
          data-testid="admin-password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoFocus
          className="w-full bg-white/5 border border-white/15 px-4 py-3 text-white placeholder:text-white/40 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/30"
          placeholder="••••••••••••"
        />

        <button
          data-testid="admin-login-submit"
          type="submit"
          disabled={loading}
          className="mt-6 w-full inline-flex items-center justify-center gap-2 bg-blue-600 text-white py-3 font-semibold hover:bg-blue-700 transition-colors disabled:opacity-50"
        >
          {loading ? <><Loader2 size={16} className="animate-spin" /> Prüfe…</> : "Anmelden"}
        </button>
      </form>
    </div>
  );
}
